import React, { useState, useRef, useEffect } from "react";
import { ChevronRightIcon } from "@heroicons/react/24/solid";

const DropdownMenu = ({ menu, childs, t, styleText = "text-gray-900" }) => {
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const numChilds = childs ? childs.length : 0;

  return (
    <div ref={containerRef} className="relative">
      {childs && childs.length != 0 ? (
        <button
          type="button"
          onClick={() => setOpen(!open)}
          className={`font-roboto group text-lg w-full flex justify-between items-center ${styleText} font-normal   px-2 py-3 lg:py-0`}
        >
          <span className="z-10">{t(`menu.${menu.name}`)}</span>
          <ChevronRightIcon className="h-4 w-4 lg:hidden transform rotate-90 md:rotate-0 " />
        </button>
      ) : (
        <a
          href={`/${menu.name}/`}
          className={`font-roboto group text-lg w-full flex justify-between items-center ${styleText} font-normal   px-2 py-3 lg:py-0`}
        >
          <span className="z-10">{t(`menu.${menu.name}`)}</span>
        </a>
      )}

      {open && (
        <div
          className={`static bg-white-presik md:absolute grid p-2 md:p-2 gap-4 origin-top w-full left-40 md:left-0 md:top-12  rounded-md   z-50 ${
            numChilds === 1
              ? "w-48 md:w-96 md:mt-0 md:ml-0 grid-cols-1"
              : "w-52 md:mt-0 md:ml-0 md:w-96 grid-cols-1 md:grid-cols-2 "
          }`}
          style={{
            minWidth: "min(90vw, 450px)",
            backgroundColor: "#ffffffcc",
            backdropFilter: "blur(8px)",
          }}
        >
          {childs &&
            childs.length != 0 &&
            childs.map((c) => (
              <a
                key={c}
                href={`/${menu.name}/${c}`}
                className="bg-white md:bg-transparent  rounded-md flex  items-center hover:bg-white text-gray-900 hover:text-gray-800  py-2 lg:py-3 px-2 pl-4 text-xl md:text-lg font-normal"
              >
                <span className="z-10">{t(`menu.${c}`)}</span>
              </a>
            ))}
          <div>
            <a
              href="https://blog.presik.com/"
              target="_blank"
              rel="noreferrer"
              className="bg-white md:bg-transparent  rounded-md flex  items-center hover:bg-white text-gray-900 hover:text-gray-800  py-2 lg:py-3 px-2 pl-4 text-xl md:text-lg font-normal"
            >
              <span className="z-10">Blog </span>
            </a>
          </div>
        </div>
      )}
    </div>
  );
};

export default DropdownMenu;
